import { SelfFixFeatures } from './self-fix-features.type';

export interface SelfFixConfig {
  commonApi: string;
  features: SelfFixFeatures;
}
